module.exports = __webpack_public_path__ + "static/PHorde2-0f28d87f6d78c882bb2061c2ab9d5f67.png";